module.exports = __webpack_public_path__ + "img/home.dc8c61d.png";